import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { getBadgesLookups, createBadge } from './thunks';
import { BadgeState } from './types';

export const name = 'badges';

const initialState: BadgeState = {
  lookups: {
    data: [],
    status: 'idle',
  },
  create: {
    data: null,
    status: 'idle',
  },
};

export const getBadgesLookupsAsync = createAsyncThunk(
  name + '/getBadgesLookups',
  getBadgesLookups
);

export const createBadgeAsync = createAsyncThunk(
  name + '/createBadge',
  createBadge
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBadgesLookupsAsync.pending, (state) => {
        state.lookups.status = 'loading';
      })
      .addCase(getBadgesLookupsAsync.fulfilled, (state, action) => {
        state.lookups = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getBadgesLookupsAsync.rejected, (state) => {
        state.lookups.status = 'failed';
      })
      .addCase(createBadgeAsync.pending, (state) => {
        state.create.status = 'loading';
      })
      .addCase(createBadgeAsync.fulfilled, (state, action) => {
        state.create = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(createBadgeAsync.rejected, (state) => {
        state.create.status = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
